// src/data/mockData.js

export const INITIAL_STATE = {
  defaultMarginPercent: 15,
  projects: {
    smith: {
      id: 'smith',
      name: 'The Smith Residence',
      address: '123 Oak Lane, Suburbia',
      clientName: 'John Smith',
      clientEmail: 'client@example.com',
      progress: 45,
      stage: 'Lock-up Stage',
      baseActualCosts: 184700,
      builderMarginPercent: 15,
      contractTotal: 450000,
      amountPaid: 185000,
      status: 'active',
      timeline: [
        { id: 1, title: 'Site Preparation', status: 'completed', date: 'Aug 15, 2026', description: 'Clearing, excavation, and leveling of the block.' },
        { id: 2, title: 'Base Stage', status: 'completed', date: 'Sep 10, 2026', description: 'Pouring concrete footings and slab.' },
        { id: 3, title: 'Frame Stage', status: 'completed', date: 'Oct 05, 2026', description: 'Erection of wall frames and roof trusses.' },
        { id: 4, title: 'Lock-up Stage', status: 'in-progress', date: 'Est. Nov 10, 2026', description: 'Brickwork, roofing, windows, and external doors.' },
        { id: 5, title: 'Fixing Stage', status: 'pending', date: '-', description: 'Internal cladding, plastering, skirting, and architraves.' },
        { id: 6, title: 'Practical Completion', status: 'pending', date: '-', description: 'Painting, installations, detailing, and final handover.' }
      ],
      updates: [
        { id: 1, author: 'Mike Builder', initials: 'MB', date: 'Yesterday at 3:45 PM', title: 'Roof trusses are up!', content: 'Great progress this week despite a little rain. The frame is completely finished, and the team successfully installed all roof trusses today. Next week we begin the brick veneer.', photos: ['https://placehold.co/600x400/e2e8f0/64748b?text=Truss+Install+1', 'https://placehold.co/600x400/e2e8f0/64748b?text=Truss+Install+2'] },
        { id: 2, author: 'Sarah Jones', initials: 'SJ', date: 'Oct 05, 2026', title: 'Slab poured successfully', content: 'The concrete pour went perfectly today. Weather held up and the slab looks great. We need to let this cure for a few days before we can start delivering the framing timber.', photos: ['https://placehold.co/800x400/e2e8f0/64748b?text=Slab+Pour'] }
      ],
      tasksAndExpenses: [
        { id: 'te1', date: 'Oct 24, 2026', description: 'Bunnings Trade - Timber & Hardware', type: 'Expense', category: 'Framing & Structure', amount: 3450.0 },
        { id: 'te2', date: 'Oct 23, 2026', description: 'Roofing Labor - Team A (32 hrs)', type: 'Task', category: 'Roofing & Exterior', amount: 2560.0 },
        { id: 'te3', date: 'Oct 20, 2026', description: 'Colorbond Steel Roofing Materials', type: 'Expense', category: 'Roofing & Exterior', amount: 12400.0 },
        { id: 'te4', date: 'Oct 15, 2026', description: 'Plumbing Rough-in Subcontractor', type: 'Expense', category: 'Plumbing & Electrical', amount: 8500.0 },
        { id: 'te5', date: 'Oct 12, 2026', description: 'Site Supervisor Check (M. Builder)', type: 'Task', category: 'Site Prep & Foundation', amount: 450.0 }
      ],
      media: [
        { id: 1, type: 'document', title: 'Approved Council Plans.pdf', date: 'Aug 10, 2026' },
        { id: 2, type: 'photo', title: 'Site Preparation Complete', date: 'Aug 15, 2026' },
        { id: 3, type: 'video', title: 'Drone Flyover - Base Stage', date: 'Sep 11, 2026' },
        { id: 4, type: 'photo', title: 'Roof Trusses Installation', date: 'Oct 06, 2026' }
      ]
    },
    miller: {
      id: 'miller',
      name: 'The Miller Build',
      address: '45 River Road, Heights',
      clientName: 'Sarah Miller',
      clientEmail: 'sarah.m@example.com',
      progress: 15,
      stage: 'Base Stage',
      baseActualCosts: 320000,
      builderMarginPercent: 20,
      contractTotal: 820000,
      amountPaid: 120000,
      status: 'starting_soon',
      timeline: [
        { id: 1, title: 'Site Preparation', status: 'completed', date: 'Nov 10, 2026', description: 'Clearing, excavation, and leveling of the block.' },
        { id: 2, title: 'Base Stage', status: 'in-progress', date: 'Est. Nov 25, 2026', description: 'Pouring concrete footings and slab.' },
        { id: 3, title: 'Frame Stage', status: 'pending', date: '-', description: 'Erection of wall frames and roof trusses.' },
        { id: 4, title: 'Lock-up Stage', status: 'pending', date: '-', description: 'Brickwork, roofing, windows, and external doors.' },
        { id: 5, title: 'Fixing Stage', status: 'pending', date: '-', description: 'Internal cladding, plastering, skirting, and architraves.' },
        { id: 6, title: 'Practical Completion', status: 'pending', date: '-', description: 'Painting, installations, detailing, and final handover.' }
      ],
      updates: [
        { id: 3, author: 'Sarah Jones', initials: 'SJ', date: 'Nov 10, 2026', title: 'Site scrape complete', content: 'Site cut is completed, setting up for plumbing pre-lay tomorrow.', photos: [] }
      ],
      tasksAndExpenses: [],
      media: [
        { id: 5, type: 'document', title: 'Initial Contract Signed.pdf', date: 'Nov 01, 2026' }
      ]
    }
  }
};

export const MOCK_XERO_PROJECTS = [
  { id: 'xprj_101', name: 'Oceanview Renovation', budget: 150000, contactName: 'David Clark' },
  { id: 'xprj_102', name: 'Riverside Extension', budget: 85000, contactName: 'Emma Wilson' }
];

export const MOCK_XERO_CONTACTS = [
  { id: 'xc_3', name: 'David Clark', email: 'david.c@example.com' },
  { id: 'xc_4', name: 'Emma Wilson', email: 'emma.w@example.com' }
];

export const MOCK_CLIENTS = [
  { id: 'c1', name: 'John Smith', email: 'client@example.com', projectId: 'smith', xeroContactId: 'xc_1', status: 'active' },
  { id: 'c2', name: 'Sarah Miller', email: 'sarah.m@example.com', projectId: 'miller', xeroContactId: 'xc_2', status: 'active' }
];